import styled from "styled-components/macro";

export const Container = styled.div`
  background-color: ${(props) => props.theme.background};
  text-align: -webkit-center;
  text-align: -moz-center;
`;
